module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.728ca639.png";